// @flow
import { Link } from 'react-router-dom'
import React, { Component, lazy, Suspense } from 'react'
import config from 'config'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import { LocaleContext } from '../../contexts/locale'
import ClubLogo from '../clubLogo'
import 'react-dropdown/style.css'
import './styles.scss'
import germanMessages from './locales/de.yml'
import frenchMessages from './locales/fr.yml'

const ClubSearch = lazy(() => import('components/clubSearch'))
const MESSAGES = {
  de: germanMessages,
  fr: frenchMessages
}

type Match = {
  id: Number,
  date: string
}

type Props = {
  handleClubSelection: number => void
}

type State = {
  matches: Array<Match>
}

export class PastMatches extends Component<Props, State> {
  state = {
    matches: [],
    groupData: {
      gender: 1,
      leagueRank: '',
      groupNumber: ''
    },
    noMatchesAvailable: false
  }
  formatDate(date) {
    return (
      date.getDate() +
      '.' +
      (date.getMonth() + 1) +
      '.' +
      date
        .getFullYear()
        .toString()
        .substr(2, 4)
    )
  }

  dateUrlToDate(dateUrl) {
    return new Date(
      dateUrl.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
    ).toLocaleDateString(this.context + '-CH', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })
  }

  formatLeagueName(leagueName) {
    const formatedName = leagueName
      .replace(/(-|\d+\.)/g, ' $1 ')
      .replace(/^\s*(\S.*\S)\s*$/g, '$1')
      .replace('inter', ' inter')
      .replace(/(\d) e/g, '$1e ')
      .replace(/\s+/g, ' ')
      .replace(/(\d+)$/, ' $1')

    return formatedName
  }

  makeDropdown(matches) {
    const m = []
    for (let i = 0; i < matches.length; i++) {
      m.push({
        label: this.formatDate(matches[i].Date),
        value: matches[i].Number
      })
    }
    return m
  }

  // Get the matches history
  getMatches() {
    let url = ''

    if (this.props.match.params.teamId) {
      url = this.props.match.params.teamId + '/matches' + '?season=2022/2023'
    } else if (this.props.match.params.leagueName) {
      url =
        'league/' +
        this.formatLeagueName(this.props.match.params.leagueName) +
        '/matches/matchday/' +
        this.props.match.params.date +
        '?season=2022/2023' +
        '&gender=' +
        this.props.match.params.gender +
        '&association=' +
        this.props.match.params.association
    }

    return window
      .fetch('https://admin-nlg-foot.tamedia.ch/api/' + url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (response.ok) {
          response = response.json()
          return response
        }

        throw new Error(response.status + ': ' + response.message)
      })
  }

  componentWillMount() {
    this.getMatches().then(data => {
      /* let matches = data['items'].map(e => {
        return {
          Date: new Date(e['Date']),
          Number: e['Number'],
          HomeTeamID: e['HomeTeamID'],
          AwayTeamID: e['AwayTeamID'],
          HomeTeam: e['HomeTeam'],
          AwayTeam: e['AwayTeam'],
          HomeTeamName: e['HomeTeamName'],
          AwayTeamName: e['AwayTeamName'],
          GoalsHome: e['GoalsHome'],
          GoalsAway: e['GoalsAway']
        }
      }) */

      let matches = data.items.reduce((filtered, e) => {
        if (!e.Suspended && !e.Temporary) {
          filtered.push({
            Date: new Date(e.Date),
            MatchDay: e.GrpMatchDay,
            Number: e.Number,
            HomeTeamID: e.HomeTeamID,
            AwayTeamID: e.AwayTeamID,
            HomeClubNumber: e.HomeTeam.ClubNumber,
            AwayClubNumber: e.AwayTeam.ClubNumber,
            HomeTeam: e.HomeTeam,
            AwayTeam: e.AwayTeam,
            HomeTeamName: e.HomeTeamName,
            AwayTeamName: e.AwayTeamName,
            GoalsHome: e.GoalsHome,
            GoalsAway: e.GoalsAway
          })
        }
        return filtered
      }, [])

      /* if (this.props.match.params.leagueName) {
        matches = matches.filter(m => {
          return m.MatchDay === +this.props.match.params.date
        })
      } */

      matches = matches.sort((a, b) => {
        return b.Date - a.Date
      })
      this.setState({
        matches: matches,
        noMatchesAvailable: matches.length == 0,
        groupData: matches.length > 0 && {
          gender: matches[0].HomeTeam.LeagueGender,
          leagueName: matches[0].HomeTeam.LeagueName.includes('interregional')
            ? 'Amateurliga - Gruppe ' + matches[0].HomeTeam.LeagueGroupNumber
            : matches[0].HomeTeam.LeagueRank +
              '. Liga - Gruppe ' +
              matches[0].HomeTeam.LeagueGroupNumber,
          leagueRank: matches[0].HomeTeam.LeagueRank,
          groupNumber: matches[0].HomeTeam.LeagueGroupNumber
        }
      })
    })
  }

  static contextType = LocaleContext

  render() {
    const errorMessage = 'Zu diesem Team gibt es noch keine Matchberichte.'
    const t = config.translationServiceFactory(MESSAGES, this.context)
    let currentteam = null
    let currentligaString = null
    if (this.state.matches[0] && this.props.match.params.teamId) {
      currentteam = [
        this.state.matches[0].HomeTeam,
        this.state.matches[0].AwayTeam
      ].find(c => c.ID === +this.props.match.params.teamId)
      currentligaString = '(' + currentteam.LeagueRank + '. Liga)'
      if (currentteam.AssociationName === 'LA') {
        currentligaString = '(Amateurliga)'
      }
    } 
    const Header = this.props.match.params.teamId ? (
      <h3 className='ui header'>
        <div className='sub header'>
          {this.props.match.params.teamId
            ? 'Mehr Matchberichte'
            : this.formatLeagueName(this.props.match.params.leagueName)}
        </div>
        {this.state.matches[0] &&
          'Die letzten Spiele von ' +
            currentteam.Name +
            ' ' +
            currentligaString +
            ':'}
      </h3>
    ) : (
      <h3 className='ui header'>
        <div className='sub header'>
          {MESSAGES.de.gender[this.state.groupData.gender]} -{' '}
          {this.state.groupData.leagueName}
        </div>
        Runde {this.props.match.params.date}
      </h3>
    )

    const Search = (
      <div className='ui container'>
        <div className='ui vertical segment'>
          <Suspense fallback={config.searchFallback}>
            <ClubSearch
              label={t('searchLabel')}
              onSelectionHandler={this.props.handleClubSelection}
            />
          </Suspense>

          <div className='teams-link'>
            <Link to='/all-teams'>
              {t('allTeams')} <i className='ui icon chevron right' />
            </Link>
          </div>
        </div>
      </div>
    )

    return (
      <>
        {Header}
        <div className='ui raised segment matches-list'>
          {this.state.matches.length === 0 && !this.state.noMatchesAvailable && (
            <div className='ui placeholder'>
              <div className='header'>
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
                <div className='line' />
              </div>
              <div className='paragraph'>
                <div className='line' />
                <div className='line' />
                <div className='line' />
              </div>
            </div>
          )}

          {this.state.matches.length === 0 && this.state.noMatchesAvailable && (
            <div className='ui text container'>
              <div className='ui icon message'>
                <i className='icon file alternate' />
                <div className='content'>
                  <div className='header'>{errorMessage}</div>
                  <p>Schauen Sie in ein paar Tagen wieder vorbei!</p>
                </div>
              </div>
            </div>
          )}


          {this.state.matches.length > 0 && (
            <>
              <table className='ui unstackable striped table mobile hidden'>
                <tbody>
                  {this.state.matches.map((m, i) => (
                    <tr
                      key={'past-match-' + i}
                      onClick={() => {
                        this.props.history.push(
                          '/article/for/match/' + m.Number
                        )
                      }}
                    >
                      <td className='date'>
                        <b>{this.formatDate(m.Date)}</b>
                      </td>
                      <td className='team home'>
                        <ClubLogo clubNumber={m.HomeClubNumber} />{' '}
                        {m.HomeTeamName}
                      </td>
                      <td className='score'>
                        <div className='mini-score'>
                          <b>{m.GoalsHome}</b>
                        </div>
                        <div className='score-sep'>:</div>
                        <div className='mini-score'>
                          <b>{m.GoalsAway}</b>
                        </div>
                      </td>
                      <td className='team away'>
                        <ClubLogo clubNumber={m.AwayClubNumber} />{' '}
                        {m.AwayTeamName}
                      </td>
                      <td className='goto-icon'>
                        <i className='ui icon icon-green chevron right' />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <table className='ui unstackable striped table mobile only'>
                <tbody>
                  {this.state.matches.map((m, i) => (
                    <tr
                      key={'past-match-' + i}
                      onClick={() => {
                        this.props.history.push(
                          '/article/for/match/' + m.Number
                        )
                      }}
                    >
                      <td className='date'>
                        <b>{this.formatDate(m.Date)}</b>
                      </td>
                      <td className='teams'>
                        <td className='team home'>
                          <div className='team-label'>
                            <ClubLogo clubNumber={m.HomeClubNumber} />
                            {m.HomeTeamName}
                          </div>
                          <div className='mini-score'>
                            <b>{m.GoalsHome}</b>
                          </div>
                        </td>
                        <td className='team away'>
                          <div className='team-label'>
                            <ClubLogo clubNumber={m.AwayClubNumber} />{' '}
                            {m.AwayTeamName}
                          </div>
                          <div className='mini-score'>
                            <b>{m.GoalsAway}</b>
                          </div>
                        </td>
                      </td>
                      <td className='goto-icon'>
                        <i className='ui icon icon-green chevron right' />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
        {Search}
      </>
    )
  }
}

export default PastMatches
